import { quotesService } from '../../services/index.js'

/**
 * Assignation au démarrage de l'appel : appeler une demande libre la donne au
 * commercial qui appelle ; annuler l'appel sans en enregistrer l'issue la rend
 * libre. Le serveur tranche (rôle commercial, demande encore libre, encore à lui).
 *
 * La prise est gardée en promesse : une annulation qui arrive avant la réponse
 * du serveur l'attend, au lieu de laisser la demande assignée.
 */
let priseEnCours = null

export function prendreDemandePourAppel(quoteId, onAssigned) {
  priseEnCours = quotesService.claimForCall(quoteId)
    .then((res) => {
      const assigned = Boolean(res?.assigned)
      if (assigned) onAssigned?.()
      return { quoteId, assigned }
    })
    .catch((err) => {
      console.error('Assignation au démarrage de l\'appel impossible', err)
      return { quoteId, assigned: false }
    })
}

export async function rendreDemandeApresAnnulation() {
  const prise = priseEnCours
  priseEnCours = null
  if (!prise) return false
  const { quoteId, assigned } = await prise
  if (!assigned) return false
  try {
    const res = await quotesService.releaseCallClaim(quoteId)
    return Boolean(res?.released)
  } catch (err) {
    console.error('Retour de la demande en « non assignée » impossible', err)
    return false
  }
}

export function oublierPriseDeLAppel() {
  priseEnCours = null
}
